import './menu.css';

import React, { useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';

import NavigationBar from '../components/navigation-bar';
import getSlug from '../service/slug-service';
import propertiesService from '../service/properties-service';
import { usePageDynamicResults } from '../hooks/use-page-dynamic';
import Masthead from '../components/masthead';
import Footer from '../components/footer';
import MenuItem from '../components/menuitem';
import Triangle from '../components/triangle';

import intrepid from '../images/logo/intrepid.webp';

const Menu = (confluencePageData) => {
  let title = confluencePageData.pageContext.title;

  let contentRef = useRef(null);

  const confluenceId = confluencePageData.pageContext.confluenceId;

  let displayHtml = confluencePageData.pageContext.bodyHtml;

  // Remove the remnants of the page contents macro
  displayHtml = displayHtml.replace(/<p><strong>[^C]*Contents<\/strong><\/p>/g, '');
  displayHtml = displayHtml.replace(/<div .*data-macro-name="detailssummary">.*<\/div>/g, '');
  displayHtml = displayHtml.replace(/<p><\/p>/g, '');
  displayHtml = displayHtml.trim();

  const data = usePageDynamicResults();

  const thisMenuPage = propertiesService.getPageByConfluenceId(data, confluenceId);

  const labels = propertiesService.getLabels(thisMenuPage);

  const props = propertiesService.getProperties(thisMenuPage);

  title = props['External Name'] ? props['External Name'] : title;

  const children = propertiesService.getChildren(data, thisMenuPage);

  let headerAttachment = propertiesService.getAttachmentByLabel(thisMenuPage, 'masthead-background');
  let headerDark = labels.includes('masthead-dark');

  let headerImage = propertiesService.getAttachmentByLabel(thisMenuPage, 'menu-header-image');
  let footerImage = propertiesService.getAttachmentByLabel(thisMenuPage, 'menu-footer-image');

  const ribbonTitleMenu = props['Featured Article Label'];

  let backgroundImage;

  let titleInMasthead = false;
  let mastheadTitle;
  let dim;

  if (!headerAttachment && thisMenuPage) {
    let i = thisMenuPage.node.ancestors.length - 1;
    while (i >= 0 && !headerAttachment) {
      const parentId = thisMenuPage.node.ancestors[i].id;
      const parent = propertiesService.getPageByConfluenceId(data, parentId);
      headerAttachment = propertiesService.getAttachmentByLabel(parent, 'masthead-background');
      const parentLabels = propertiesService.getLabels(parent);
      headerDark = parentLabels.includes('masthead-dark');
      if (headerAttachment) {
        backgroundImage = '/' + parentId + '-' + headerAttachment?.title;
      }
      i--;
    }
  } else if (thisMenuPage && headerAttachment) {
    backgroundImage = '/' + thisMenuPage.node.confluenceId + '-' + headerAttachment?.title;
  }

  if (headerAttachment) {
    dim = 0;
  }

  let mastheadSubTitle = props['Subtitle'];

  if (mastheadSubTitle) {
    mastheadTitle = title;
    titleInMasthead = true;
  }

  let menuType = labels.find((l) => l.startsWith('menu-type-'));
  menuType = menuType ? menuType.replace('menu-type-', '') : 'plain';

  let center = labels.includes('center-content') ? 'content-container-center-content' : '';

  let contentContainerClass = `content-container-${menuType} ${center}`;

  if (menuType === 'panel') {
    if (children.length % 2 === 0) {
      contentContainerClass += ` content-container-panel-two-wide`;
    } else if (children.length % 3 === 0) {
      contentContainerClass += ` content-container-panel-three-wide`;
    }
  }

  var childContent = children.sort(propertiesService.sortResults(labels)).map((childPage) => {
    const slug = getSlug(childPage.node.title);
    const props = propertiesService.getProperties(childPage);
    const version = props['Version'];
    const publicationDate = propertiesService.getPropertyAsDate(childPage, 'Publication Date');
    const subtitle = props['Menu Preview'] || props['Subtitle'];
    const highlightText = props['Featured Highlight Text'];
    const ribbonTitle = props['Featured Article Label'] || ribbonTitleMenu;

    const description = [];
    if (props['Description']) description.push(props['Description']);
    if (props['Description 2']) description.push(props['Description 2']);
    if (props['Description 3']) description.push(props['Description 3']);
    const title = props['External Name'] ? props['External Name'] : childPage.node.title;

    const childLabels = propertiesService.getLabels(childPage);

    // look for the menu type label
    const menuItemTypeLabelPrefix = 'menu-item-type-';
    const menuItemTypeLabels = childLabels.find((label) => label.startsWith(menuItemTypeLabelPrefix));
    let itemType;
    if (menuItemTypeLabels && menuItemTypeLabels.length) {
      itemType = menuItemTypeLabels.replace(menuItemTypeLabelPrefix, '');
    }

    const dates = props['Dates'];

    const publicationDateStr = publicationDate === undefined ? '' : publicationDate.toLocaleDateString();
    const previewAttachment = propertiesService.getAttachmentByLabel(childPage, 'menu-preview');
    let previewImage = childLabels.includes('no-preview-image') ? undefined : intrepid;
    if (previewAttachment) {
      previewImage = '/' + childPage.node.confluenceId + '-' + previewAttachment.title;
    }

    const modalCenter = childLabels.includes('center-content') ? 'item-container-modal-content-center' : '';
    const modalClass = `item-container-modal-content item-container-modal-content-${menuType} ${modalCenter}`;
    let childHtml;

    if (childLabels.includes('popout')) {
      childHtml = propertiesService.replaceImages(childPage.node.confluenceId, childPage.node.bodyExport, [1]);
    }

    const thisChild = propertiesService.getPageByConfluenceId(data, childPage.node.confluenceId);

    const subChildren = propertiesService.getChildren(data, thisChild);

    return (
      <MenuItem
        key={slug}
        type={menuType}
        subtype={itemType}
        title={title}
        ribbonTitle={ribbonTitle}
        image={previewImage}
        date={publicationDateStr || dates}
        version={version}
        slug={slug}
        description={description}
        subtitle={subtitle}
        highlightText={highlightText}
        modal_content={childHtml}
        modal_class={modalClass}
        subChildren={subChildren}
      />
    );
  });

  return (
    <div className="_container">
      <NavigationBar />
      <Masthead
        title={mastheadTitle}
        subTitle={mastheadSubTitle}
        backgroundImage={backgroundImage}
        dim={dim}
        darkMode={headerDark}
      />

      <div className="menu">
        <div className={contentContainerClass} ref={contentRef}>
          {titleInMasthead ? '' : <h1 className="title">{title}</h1>}

          {headerImage ? (
            <img
              className="header-image"
              src={'/' + thisMenuPage.node.confluenceId + '-' + headerImage?.title}
              alt="header"
            />
          ) : (
            ''
          )}

          {['accordion', 'icon', 'panel'].includes(menuType) && displayHtml ? (
            <div
              dangerouslySetInnerHTML={{ __html: displayHtml }}
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            />
          ) : (
            ''
          )}

          {menuType === 'accordion' ? <Accordion>{childContent}</Accordion> : childContent}

          <Triangle
            bottomY={900}
            topY={500}
            width={170}
            innerY={400}
            color="#ffb81c"
            side="left"
            parentRef={contentRef}
          />
          <Triangle
            bottomY={890}
            topY={500}
            width={180}
            innerY={600}
            color="#ffb81c"
            side="right"
            parentRef={contentRef}
          />
          <Triangle
            bottomY={1350}
            topY={1100}
            width={150}
            innerY={1250}
            color="#ffb81c"
            side="left"
            parentRef={contentRef}
          />
          <Triangle
            bottomY={1730}
            topY={1500}
            width={250}
            innerY={1550}
            color="#ffb81c"
            side="right"
            parentRef={contentRef}
          />

          {footerImage ? (
            <img
              className="footer-image"
              src={'/' + thisMenuPage.node.confluenceId + '-' + footerImage?.title}
              alt="footer"
            />
          ) : (
            ''
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Menu;
